import React from 'react'
import '../../dist/loaderStyle.css'

const ModalLoader = () => {
  return (
    <span className="loader"></span>
  )
}

export default ModalLoader